import tinymce, { type Editor } from 'tinymce/tinymce';
import { wrapMathML } from './editorHelpers';

const mathIcon =
  '<svg width="24" height="24" viewBox="0 0 24 24"><text x="2" y="18" font-size="16" font-family="serif" font-style="italic">∑</text></svg>';

const isMathML = (text: string): boolean => {
  return /<math[\s>]/i.test(text);
};

// existingWrapper: the .math-node span (or bare <math> for legacy content) to replace;
// null means insert new math.
const openMathDialog = (editor: Editor, existingWrapper: HTMLElement | null = null) => {
  // When editing an existing block, show the inner <math> markup without the wrapper span.
  const mathNode =
    existingWrapper?.tagName?.toLowerCase() === 'math'
      ? existingWrapper
      : (existingWrapper?.querySelector('math') as HTMLElement | null);
  const existingMathML = mathNode?.outerHTML ?? '';

  editor.windowManager.open({
    title: 'Wiskundige formule invoegen',
    body: {
      type: 'panel',
      items: [
        {
          type: 'textarea',
          name: 'mathml',
          label: 'Plak hier MathML',
        },
      ],
    },
    buttons: [
      { type: 'cancel', text: 'Annuleren' },
      { type: 'submit', text: 'Invoegen', primary: true },
    ],
    initialData: { mathml: existingMathML },
    onSubmit: (api) => {
      const { mathml } = api.getData();
      if (mathml && isMathML(mathml)) {
        if (existingWrapper) {
          editor.selection.select(existingWrapper);
        }
        editor.selection.setContent(wrapMathML(mathml));
        editor.setDirty(true);
      }
      api.close();
    },
  });
};

const exists = tinymce.PluginManager.get('math');
if (!exists) {
  tinymce.PluginManager.add('math', (editor) => {
    editor.ui.registry.addIcon('mathIcon', mathIcon);

    editor.ui.registry.addButton('math', {
      icon: 'mathIcon',
      tooltip: 'Wiskundige formule',
      onAction: () => {
        const node = editor.selection.getNode() as HTMLElement;
        const wrapper = node.closest?.('.math-node') as HTMLElement | null;
        openMathDialog(editor, wrapper);
      },
    });

    editor.ui.registry.addMenuItem('math', {
      icon: 'mathIcon',
      text: 'Wiskundige formule',
      onAction: () => openMathDialog(editor, null),
    });

    // Allow double-click on math element to edit
    editor.on('dblclick', (evt) => {
      const target = evt.target as HTMLElement;
      const wrapperEl = target.closest('.math-node') as HTMLElement | null;
      if (wrapperEl) {
        editor.selection.select(wrapperEl);
        openMathDialog(editor, wrapperEl);
      }
    });

  });
}
